import Api from "../../../../service";
import {
  RESET_NATIONALTEAM_COACHES,
  SET_ERROR,
  SET_NATIONALTEAM_COACHES,
} from "./constants";

const setNationalTeamCoaches = (data) => ({
  type: SET_NATIONALTEAM_COACHES,
  data,
});

export const resetNationalTeamCoaches = (data) => ({
  type: RESET_NATIONALTEAM_COACHES,
  data,
});

const setError = (data) => ({
  type: SET_ERROR,
  data,
});

export const getNationalTeamCoaches = (data) => (dispatch) =>
  Api.nationalTeam
    .getCoaches(data)
    .then((response) => {
      dispatch(setNationalTeamCoaches(response));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error));
    });
